import React from "react";
import classnames from "classnames";
import { useSelector } from "react-redux";

import {
  getCurrentDispensary,
  getIsUnclaimed,
} from "redux/selectors/dispensary";
import { trackMenuEvent } from "utils/trackEvent";

import PhoneIcon from "components/Icons/phone.svg";

const CallDispensary = ({ displayNumber = true }) => {
  const { phone } = useSelector(getCurrentDispensary);
  const isUnclaimed = useSelector(getIsUnclaimed);

  const clickPhone = () => {
    trackMenuEvent("Header", "Call");
  };

  const actionText = displayNumber ? phone : "Call";

  if (!phone) {
    return null;
  }

  return (
    <div>
      {!isUnclaimed && (
        <a
          aria-label="Call"
          onClick={clickPhone}
          href={`tel:${phone}`}
          data-testid="dispensary-header-call"
        >
          <div
            className={classnames("text-xs items-center", {
              "flex text-green text-sm": displayNumber,
            })}
          >
            <PhoneIcon
              width="20"
              height="20"
              className={classnames({
                "mb-sm mx-auto": !displayNumber,
                "mr-sm": displayNumber,
              })}
            />
            {actionText}
          </div>
        </a>
      )}

      {isUnclaimed && displayNumber && (
        <div className="text-sm mb-xs flex items-center">{phone}</div>
      )}
    </div>
  );
};

export default CallDispensary;
